module.exports = __webpack_public_path__ + "static/img/bg-2.527d86b9.png";